import { autoinject } from "aurelia-framework";
import { TitleConst } from "../../../constants/title.constaints";
import { Router } from "aurelia-router";
import { RsInspectionRouteConstants } from "../../../constants/route.constants";
import { RightshipInspectionService } from "../../../services/rightship-inspection.service";
import { RightShipInspectionDetailsModel } from "../../../models/rightship-inspections.models";

@autoinject
export class CloseRequest {
    public isDeclined: boolean;
    public hideCloseTab: boolean = false;
    public inspectionModel: RightShipInspectionDetailsModel;
    private _encryptedData: string;

    constructor(private router: Router, private rightshipInspectionService: RightshipInspectionService) {
    }

    async activate(params: { vesselName: string, vesselImo: string, portName: string, country: string, requestedInspectionDate: string, isDeclined: string, encryptedData: string, hideCloseTab: string, inspectionDetailModel?: RightShipInspectionDetailsModel }) {
        this._encryptedData = decodeURIComponent(params.encryptedData);
        this.inspectionModel = params.inspectionDetailModel ? params.inspectionDetailModel : await this.rightshipInspectionService.getRightShipInspectionDetails(this._encryptedData);
        this.isDeclined = params.isDeclined === "true";
        this.hideCloseTab = params.hideCloseTab === "true";
    }

    get title() {
        return this.isDeclined ? TitleConst.DeclineProposal: TitleConst.ClosedProposal;
    }

    //Return to inspection page
    close() {
        this.router.navigateToRoute(RsInspectionRouteConstants.Inspection, {
            encryptedData: encodeURIComponent(this._encryptedData)
        });
    }
}